import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { api } from "../../../../config/api";
import { BackEndRoutes } from "../../../../config/back-end-routes";
import DefaultGrid from "../../../../Components/Default/DefaultGrid";
import AddPaymentTermModal from "./ModalAddPrazo";
import DeleteConfirmationModal from "./ModalDeletePrazo";
import {useFilters} from "../../../../Components/Filters/UseFilter";

const PagePaymentTerms: React.FC = () => {
    const [paymentTerms, setPaymentTerms] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [selectedItem, setSelectedItem] = useState<any>(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const { filters, handleFilterChange } = useFilters([]);
    const [filteredPaymentTerms, setFilteredPaymentTerms] = useState<any[]>([]);

    const columns = [
        { key: "id_prazo", label: "Código", filterType: "text" as const, disable: true },
        { key: "descricao", label: "Descrição", filterType: "text" as const },
        {
            key: "status",
            label: "Status",
            filterType: "select",
            options: [
                { value: "1", description: "Ativo" },
                { value: "0", description: "Inativo" },
            ],
            render: (item: any) => (
                <select
                    className="form-select"
                    value={item.status}
                    onChange={(e) => {
                        const newStatus = parseInt(e.target.value, 10);
                        api.put(
                            BackEndRoutes.routes.PRAZOS_PAGAMENTOS.FIND.replace(":id", item.id_prazo),
                            { descricao: item.descricao, status: newStatus }
                        )
                            .then(() => {
                                setPaymentTerms((prev) =>
                                    prev.map((term) =>
                                        term.id_prazo === item.id_prazo
                                            ? { ...term, status: newStatus }
                                            : term
                                    )
                                );
                                toast.success("Status atualizado com sucesso!");
                            })
                            .catch(() => {
                                toast.error("Erro ao atualizar status.");
                            });
                    }}
                >
                    <option value={1}>Ativo</option>
                    <option value={0}>Inativo</option>
                </select>
            ),
        },
    ];

    const fetchPaymentTerms = () => {
        setLoading(true);
        api.get(BackEndRoutes.routes.PRAZOS_PAGAMENTOS.LIST)
            .then((res) => {
                setPaymentTerms(res.data);
                setFilteredPaymentTerms(res.data);  // Inicializa a lista filtrada com todos os itens
            })
            .catch(() => {
                toast.error("Erro ao carregar prazos de pagamento.");
            })
            .finally(() => setLoading(false));
    };

    const handleAddPaymentTerm = () => {
        setShowAddModal(true);
    };

    const handleEditPaymentTerm = (item: any) => {
        setSelectedItem(item);
        setShowAddModal(true);
    };

    const handleDeletePaymentTerm = () => {
        if (!selectedItem) return;
        setLoading(true);
        api.delete(
            BackEndRoutes.routes.PRAZOS_PAGAMENTOS.DELETE.replace(":id", String(selectedItem.id_prazo))
        )
            .then(() => {
                toast.success("Prazo de pagamento excluído com sucesso!");
                setPaymentTerms((prev) =>
                    prev.filter((term) => term.id_prazo !== selectedItem.id_prazo)
                );
                setFilteredPaymentTerms((prev) =>
                    prev.filter((term) => term.id_prazo !== selectedItem.id_prazo)
                );
                setShowDeleteModal(false);
                setSelectedItem(null);
            })
            .catch(() => {
                toast.error("Erro ao excluir prazo de pagamento.");
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchPaymentTerms();
    }, []);

    return (
        <div className="d-flex flex-column container-fluid">
            <DefaultGrid
                title="Prazos de Pagamento"
                onAdd={handleAddPaymentTerm}
                columns={columns}
                filters={filters}
                handleFilterChange={handleFilterChange}
                items={filteredPaymentTerms}
                itemsPerPage={10}
                loading={loading}
                onReload={fetchPaymentTerms}
                onEdit={handleEditPaymentTerm}
                onDelete={(item: any) => {
                    setSelectedItem(item);
                    setShowDeleteModal(true);
                }}
            />
            {showAddModal && (
                <AddPaymentTermModal
                    show={showAddModal}
                    onHide={() => setShowAddModal(false)}
                    onSave={fetchPaymentTerms}
                    term={selectedItem}
                />
            )}
            {showDeleteModal && (
                <DeleteConfirmationModal
                    show={showDeleteModal}
                    onHide={() => setShowDeleteModal(false)}
                    onConfirm={handleDeletePaymentTerm}
                />
            )}
        </div>
    );
};

export default PagePaymentTerms;